import { render } from "./SingleLead.vue?vue&type=template&id=a290f3d6&scoped=true"
import script from "./SingleLead.vue?vue&type=script&lang=js"
export * from "./SingleLead.vue?vue&type=script&lang=js"

import "./SingleLead.vue?vue&type=style&index=0&id=a290f3d6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a290f3d6"]])

export default __exports__